import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import CryptoJS from 'crypto-js'
import { getBaseURL } from '../../URLs'
import './validatedNameSignature.scss'
export default (props) => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [name, setName] = useState('')
    // const [coRoot, setcoRoot] = useState('');
    const [showModal, setShowModal] = useState(false)

    const inputUsername = useRef(null)

    useEffect(() => {
        setName(props.defaultValue)
    }, [props.defaultValue])

    const handleClose = () => setShowModal(false)
    const handleSignClick = () => {
        if (!props.disabled) {
            if (props.preCheck) {
                if (props.preCheck().canRaise) setShowModal(true)
            } else setShowModal(true)

            setUsername('')
            setPassword('')
        }
    }

    const handleSubmitOnEnter = (e) => {
        var key = e.which || e.keyCode || 0
        key === 13 && handleLoginClick()
    }

    const handleLoginClick = () => {
        const randomiv = CryptoJS.lib.WordArray.random(128 / 8)
        const key = CryptoJS.enc.Base64.parse('bYtsiQNlLNnBQPuMiUOOHsIpNOjCfsAiDfYg5Iy8BaQ=')
        const c = CryptoJS.AES.encrypt(password, key, { iv: randomiv })
        const b64Ciphertext = c.ciphertext.toString(CryptoJS.enc.Base64)
        const b64IV = c.iv.toString(CryptoJS.enc.Base64)
        fetch(`${getBaseURL()}webapi/user/AuthenticateSignature`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username,
                ciphertext: b64Ciphertext,
                iv: b64IV,
            }),
        })
            .then((response) => {
                if (response.ok) return response.json()
                return response.text()
            })
            .then((results) => {
                if (typeof results === 'string') throw Error(results)

                let n = `${results.firstname.trim()} ${results.lastname.trim()}`
                let canSign = true
                if (props.onSuccess !== undefined) canSign = props.onSuccess()

                if (canSign) {
                    setName(n)
                    if (props.onChange) {
                        props.onChange(n)
                        console.warn('Blurring')
                        props.onSuccessAfterChange(n)
                    }
                    setShowModal(false)
                } else setShowModal(false)
            })
            .catch((error) => {
                alert(error)
                if (inputUsername.current) inputUsername.current.focus()
            })
    }

    const handleUnSignClick = () => {
        if (!props.disabled) {
            setUsername('')
            setName('')
            setPassword('')
            setShowModal(false)
            if (props.onChange) props.onChange('')
        }
    }

    const handlePasswordChange = (event) => {
        // console.log('start')
        // console.log(event)
        // const value=event.target.value
        // const digit=value.replace(/\*/g, '')
        // if(digit !==''){
        //     let index=-1
        //     for(let i=0;i<value.length;i++){
        //         if(value[i]!=='*'){
        //             index=i
        //             break
        //         }
        //     }

        //     let newPassword=''
        //     if(index !==-1){
        //         console.log('value '+value)
        //         console.log('password '+password)
        //         console.log('password substring '+password.substring(0,index))

        //         newPassword=password.substring(0,index)+digit+password.substring(index+1)
        //         console.log('password second substring '+password.substring(index+1))
        //     }
        //     else{
        //         newPassword=digit
        //     }

        //     setPassword(newPassword)
        //     setMaskedInput(value.replace(/[a-zA-Z0-9]/g, '*'))
        // }
        setPassword(event.target.value)
    }

    const maskValue = (value) => {
        return value.replace(/./g, '*')
    }
    return (
        <div className='validated-name-signature'>
            {name === '' && (
                <>
                    <input
                        className='validation-dummy'
                        style={{ width: '20px' }}
                        onKeyPress={(e) => e.preventDefault()}
                        required={props.required}
                    ></input>
                    <span
                        className='glyphicon glyphicon-pencil'
                        onClick={handleSignClick}
                        style={{ cursor: 'pointer' }}
                    >
                        {props.disabled ? '  Locked' : ''}
                    </span>
                    <Modal
                        show={showModal}
                        dialogClassName='validated-name-signature-modal-dialog'
                        backdropClassName='veil'
                        animation={false}
                        size='lg'
                        centered
                        autoFocus={false}
                        onHide={handleClose}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title style={{ display: 'inline-block' }}>
                                User Authentication
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form className='form-inline'>
                                <div
                                    className='form-group'
                                    style={{
                                        paddingBottom: '10px',
                                    }}
                                >
                                    <label style={{ width: 150 }}>Username:</label>

                                    <input
                                        ref={inputUsername}
                                        name='Credential'
                                        type='text'
                                        className='form-control form-control-sm'
                                        maxLength='20'
                                        autoFocus={true}
                                        defaultValue={username}
                                        required
                                        autoComplete='off'
                                        onKeyPress={handleSubmitOnEnter}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>
                                <div className='form-group'>
                                    <label style={{ width: 150 }}>Last 4 digits of SSN:</label>
                                    <div className='mask'>{maskValue(password)}</div>
                                    <input
                                        name='LastFour'
                                        type='text'
                                        className='form-control form-control-sm inputLastFour'
                                        value={password}
                                        maxLength={4}
                                        required
                                        autoComplete='off'
                                        onKeyPress={handleSubmitOnEnter}
                                        onChange={(e) => handlePasswordChange(e)}
                                    />
                                </div>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant='primary' onClick={handleLoginClick}>
                                Sign
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
            {name !== '' && (
                <div
                    className={
                        props.disabled
                            ? 'validated-name-signature-signed-disabled'
                            : 'validated-name-signature-signed'
                    }
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <span
                        style={{
                            fontStyle: 'italic',
                            textDecoration: 'underline',
                        }}
                    >
                        {name}
                    </span>
                    <button
                        onClick={handleUnSignClick}
                        type='button'
                        className='close'
                        style={{ paddingLeft: '10px' }}
                    >
                        <span aria-hidden='true'>×</span>
                        <span className='sr-only'>Close</span>
                    </button>
                </div>
            )}
        </div>
    )
}
